import { Injectable } from '@angular/core';
import { CustomOrderEntry } from '@cart/const';
import { ActiveCartService } from '@cart/data-access';
import { getCartIdByUserId } from '@cart/utils';
import { SnackTheme } from '@main/snackbar/const';
import { SnackbarFacade } from '@main/snackbar/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { RepeatOrderParams } from '@order/const';
import { OccOrderService, OrderActions } from '@order/data-access';
import { CartModification, UserIdService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class OnlineOrderRepeatEffect {
  repeatOrder$: Observable<OrderActions.OnlineOrderRepeatActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.ONLINE_ORDER_REPEAT),
      map((action: OrderActions.OnlineOrderRepeat) => action.payload),
      switchMap(({ orderCode }) =>
        this.activeCartService.requireLoadedCart().pipe(
          withLatestFrom(this.userIdService.getUserId()),
          map(([cartState, userId]) => ({ cartId: getCartIdByUserId(cartState.value, userId) })),
          take(1),
          map(({ cartId }) => ({ cartId, orderCode })),
          filter(({ cartId }: RepeatOrderParams) => !!cartId && !!orderCode),
        ),
      ),
      switchMap((payload) =>
        this.occOrderService.repeatOrder(payload).pipe(
          map((data) => {
            data.cartModifications
              .filter((item: CartModification) => item.quantity !== item.quantityAdded)
              .forEach((item) => {
                {
                  this.snackbarFacade.setSnack({
                    title: item.entry.product.name,
                    text:
                      item.quantityAdded === 0
                        ? `Товар отсутствует`
                        : `Осталость только ${item.quantityAdded} ${
                            (item.entry as CustomOrderEntry).saleUnit?.name || ''
                          }`,
                    delay: 5000,
                  });
                }
              });

            return new OrderActions.OnlineOrderRepeatSuccess();
          }),
          catchError((error: unknown) => {
            this.snackbarFacade.setSnack({
              theme: SnackTheme.Yellow,
              title: 'Ошибка',
              text: 'Не удалось повторить заказ',
            });

            return of(new OrderActions.OnlineOrderRepeatFail({ error }));
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private occOrderService: OccOrderService,
    private snackbarFacade: SnackbarFacade,
    private activeCartService: ActiveCartService,
    private userIdService: UserIdService,
  ) {}
}
